import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Label = styled.div`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
`

export const Cols = styled.div`
  display: flex;
  flex-direction: column;

  :first-child {
    gap: 12px;
  }

  gap: 16px;

  border-radius: 8px;
  background: var(--Background-Page-faded, #fafafa);
  padding: 16px;
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;
  gap: 16px;
`

export const ColsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ColHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: start;
`

export const AddButton = styled.button`
  margin-top: 4px;
  display: flex;
  height: 48px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  align-self: stretch;

  border-radius: 8px;
  border: none;
  background: var(--Background-Page-faded, #fafafa);

  color: #4d4be7;
  cursor: pointer;

  color: var(--Foreground-Primary, #4d4be7);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`

export const DeleteIcon = styled.img`
  cursor: pointer;
`
